import type { ArchbaseRemoteApiClient } from '@archbase/data'
import { injectable, inject } from 'inversify'
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core'
import type { UsageListResponse } from '@domain/usage/UsageDto'

@injectable()
export class DoclenzUsageService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  /** Consumo por tenant, já cruzado com a cota de cada um. */
  async findAll(): Promise<UsageListResponse> {
    return this.client.get('/v1/admin/usage')
  }

  /** Estado da API e dos workers. Público — não exige credencial. */
  async health(): Promise<{ status: string; service: string; workers: Record<string, string> }> {
    return this.client.get('/v1/health', {}, true)
  }
}
